import type { User } from '~/types/auth'
import {defineStore} from "pinia";

export const useAuthStore = defineStore('auth', () => {
    const token = useCookie<string | null>('auth_token', {
        maxAge: 60 * 60 * 24 * 7, // 7 days
        secure: import.meta.env.PROD, // note: secure cookie in production
        sameSite: 'lax',
        domain: import.meta.env.PROD ? '.sabzlearn.ir' : undefined,
        default: () => null
    });
    const isLoggedIn = ref<boolean>(false);
    const authLoading = ref<boolean>(false);
    const user = ref<User | null>(null);

    function setToken(newToken: string) {
        token.value = newToken;
    }

    function clearToken() {
        isLoggedIn.value = false;
        token.value = null;
    }

    function setUser(newUser: User) {
        user.value = newUser;
        isLoggedIn.value = true;
    }

    function logout() {
        clearToken();
        user.value = null;
    }

    function setAuthLoading(loading: boolean) {
        authLoading.value = loading;
    }

    return {
        token,
        isLoggedIn,
        authLoading,
        user,
        setToken,
        clearToken,
        setUser,
        logout,
        setAuthLoading
    }
})

